import { wait } from '../utils/timing'

import type { TElement, IAnimRunProps } from './Anim'
import Anim from './Anim'

type TAnimCallback = (el: HTMLElement) => void

type TProps = Omit<IAnimRunProps, 'el'>

export interface IAnimProps extends TProps {
  /** Lehet kikapcsolt állapotban is, akkor egyből átugorja. Default: aktív. */
  readonly isActive?: boolean | undefined
  /** Animálandó elem. */
  readonly children?: TElement[]
  /** Anim delay (várakozás), az animáció kezdése előtt. */
  readonly delay?: number
  /** Anim inicializálásakor fut meg. */
  readonly onInit?: TAnimCallback
  /** Anim indulásakor fut meg. */
  readonly onStart?: TAnimCallback
  /** Anim végén fut meg. */
  readonly onEnd?: TAnimCallback
}

/**
 * Anim TSX.
 * @param props - Beállítások.
 */
function TSXAnim (props: IAnimProps): HTMLElement { // eslint-disable-line @typescript-eslint/naming-convention -- TSX.
  const {
    children, delay, duration, name,
    onEnd   = () => { /* noop */ },
    onInit  = () => { /* noop */ },
    onStart = () => { /* noop */ } // !!! Az onStart csak delay-t használva fut meg !!!
  } = props

  const tmp       = children as HTMLElement[]
  const [ child ] = tmp
  const isActive  = props.isActive !== false // ez fontos, mert szinte sehol sincs használva

  /** Animáció indítása. */
  async function run (): Promise<void> {
    await Anim.run({
      el: child,
      name,
      duration
    })

    onEnd(child)
  }

  if (isActive) {
    onInit(child)

    if (delay) {
      // eslint-disable-next-line no-restricted-syntax -- Legacy.
      wait(delay).then(() => {
        onStart(child)
        run()
      })
    }
    else {
      run()
    }
  }
  else {
    onEnd(child)
  }

  return child
}

TSXAnim.ANIMS = Anim.ANIMS

export default TSXAnim
